module.exports = __webpack_public_path__ + "img/zoom-workplace-text.16c9aadf.svg";